<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  #formRef="ngForm"
  [patchForm]="formValues$ | async"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          (click)="isCollapsed = !isCollapsed"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          aria-controls="my-work"
        >
          <span class="fs-3">{{ 'employeeModule.myWork' | translate }}</span>
          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div *ngIf="!isCollapsed" class="card-body" id="my-work">
      <div class="mb-4">
        <label class="form-label">{{
          'configurationOptionModule.employeeCalendarDaysAheadAvailable'
            | translate
        }}</label>

        <input
          type="number"
          class="form-control"
          formControlName="employee_calendar_days_ahead_available"
        />
      </div>

      <fieldset class="mb-4">
        <legend class="form-label">{{
          'configurationOptionModule.employeeCalendarMaxDateAvailable'
            | translate
        }}</legend>

        <datetime-input
          formControlName="employee_calendar_max_date_available"
          [hideTime]="true"
        ></datetime-input>
      </fieldset>

      <form [formGroup]="attachDocumentsToInvoiceForm">
        <div class="mb-4">
          <label class="form-label">{{
            'configurationOptionModule.attachDocumentsToInvoice' | translate
          }}</label>
          <div class="form-check">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="attachDocumentsToInviceIsVisible"
                formControlName="isVisible"
              />
              <label for="descriptionIsEditable">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="form-check">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="attachDocumentsToInviceIsRequired"
                formControlName="isRequired"
              />
              <label for="descriptionIsRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
          </div>
        </div>
      </form>

      <div class="mb-4">
        <label class="form-label">
          {{ 'configurationOptionModule.employeeText' | translate }}
        </label>
        <div class="row">
          <div class="col-lg-6 mb-3" *ngIf="availableLanguages['nl']">
            <span
              class="flag flag-nl mb-2"
              role="img"
              attr.aria-label="{{ 'wcag.nl' | translate }}"
            ></span>

            <div
              [ngxSummernote]="config"
              formControlName="nl_employees_calendar_text"
              [attr.aria-invalid]="
                form.controls.nl_employees_calendar_text.dirty &&
                form.controls.nl_employees_calendar_text.invalid &&
                form.controls.nl_employees_calendar_text.errors
                  ? 'true'
                  : null
              "
            ></div>
          </div>
          <div class="col-lg-6 mb-3" *ngIf="availableLanguages['en']">
            <span
              class="flag flag-en mb-2"
              role="img"
              attr.aria-label="{{ 'wcag.en' | translate }}"
            ></span>
            <div
              [ngxSummernote]="config"
              formControlName="en_employees_calendar_text"
              [attr.aria-invalid]="
                form.controls.en_employees_calendar_text.dirty &&
                form.controls.en_employees_calendar_text.invalid &&
                form.controls.en_employees_calendar_text.errors
                  ? 'true'
                  : null
              "
            ></div>
          </div>
          <div class="col-lg-6 mb-3" *ngIf="availableLanguages['fr']">
            <span
              class="flag flag-fr mb-2"
              role="img"
              attr.aria-label="{{ 'wcag.fr' | translate }}"
            ></span>

            <div
              [ngxSummernote]="config"
              formControlName="fr_employees_calendar_text"
              [attr.aria-invalid]="
                form.controls.fr_employees_calendar_text.dirty &&
                form.controls.fr_employees_calendar_text.invalid &&
                form.controls.fr_employees_calendar_text.errors
                  ? 'true'
                  : null
              "
            ></div>
          </div>
          <div class="col-lg-6 mb-3" *ngIf="availableLanguages['de']">
            <span
              class="flag flag-de mb-2"
              role="img"
              attr.aria-label="{{ 'wcag.de' | translate }}"
            ></span>
            <div
              [ngxSummernote]="config"
              formControlName="de_employees_calendar_text"
              [attr.aria-invalid]="
                form.controls.de_employees_calendar_text.dirty &&
                form.controls.de_employees_calendar_text.invalid &&
                form.controls.de_employees_calendar_text.errors
                  ? 'true'
                  : null
              "
            ></div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end pt-3">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>
